import { useEffect } from 'react';

/**
 * Reliably injects a JSON-LD <script type="application/ld+json"> into <head>.
 * Works with React 18 (avoids react-helmet 6.x script-injection issues).
 *
 * Each instance manages its own script tag and cleans up on unmount.
 */
let counter = 0;

const JsonLd = ({ data }) => {
  useEffect(() => {
    const id = `jsonld-${++counter}`;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [data]);

  return null;
};

export default JsonLd;
